document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('CollectionsFilterDrawer');
  if (!drawer) return;

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  var openBtn = document.querySelector('[data-collections-filter-open]');
  var scrollY = 0;
  var bodyLockStyles = {
    position: '',
    top: '',
    left: '',
    right: '',
    width: ''
  };
  var htmlLockStyles = {
    position: '',
    top: '',
    left: '',
    right: '',
    width: '',
    height: ''
  };
  var overscrollCleanup = null;
  var viewportSyncHandler = null;

  function syncDrawerToVisualViewport() {
    if (!window.visualViewport) return;

    var vv = window.visualViewport;
    drawer.style.top = vv.offsetTop + 'px';
    drawer.style.left = vv.offsetLeft + 'px';
    drawer.style.width = vv.width + 'px';
    drawer.style.height = vv.height + 'px';
    drawer.style.right = 'auto';
    drawer.style.bottom = 'auto';
  }

  function resetDrawerViewport() {
    drawer.style.top = '';
    drawer.style.left = '';
    drawer.style.width = '';
    drawer.style.height = '';
    drawer.style.right = '';
    drawer.style.bottom = '';
  }

  function enableViewportSync() {
    if (!window.visualViewport) return;

    viewportSyncHandler = syncDrawerToVisualViewport;
    window.visualViewport.addEventListener('resize', viewportSyncHandler);
    window.visualViewport.addEventListener('scroll', viewportSyncHandler);
    syncDrawerToVisualViewport();
  }

  function disableViewportSync() {
    if (!window.visualViewport || !viewportSyncHandler) return;

    window.visualViewport.removeEventListener('resize', viewportSyncHandler);
    window.visualViewport.removeEventListener('scroll', viewportSyncHandler);
    viewportSyncHandler = null;
    resetDrawerViewport();
  }

  function bindOverscrollPrevention(scrollEl) {
    if (!scrollEl) return function () {};

    var touchStartY = 0;

    function onTouchStart(event) {
      if (event.touches.length !== 1) return;
      touchStartY = event.touches[0].clientY;
    }

    function onTouchMove(event) {
      if (event.touches.length !== 1) return;

      var deltaY = event.touches[0].clientY - touchStartY;
      var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;

      if ((scrollEl.scrollTop <= 0 && deltaY > 0) || (scrollEl.scrollTop >= maxScroll && deltaY < 0)) {
        event.preventDefault();
      }
    }

    function onWheel(event) {
      var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;

      if ((scrollEl.scrollTop <= 0 && event.deltaY < 0) || (scrollEl.scrollTop >= maxScroll && event.deltaY > 0)) {
        event.preventDefault();
      }
    }

    scrollEl.addEventListener('touchstart', onTouchStart, { passive: true });
    scrollEl.addEventListener('touchmove', onTouchMove, { passive: false });
    scrollEl.addEventListener('wheel', onWheel, { passive: false });

    return function cleanup() {
      scrollEl.removeEventListener('touchstart', onTouchStart);
      scrollEl.removeEventListener('touchmove', onTouchMove);
      scrollEl.removeEventListener('wheel', onWheel);
    };
  }

  function lockScroll() {
    scrollY = window.scrollY;
    document.documentElement.classList.add('overflow-hidden', 'collections-filter-drawer-open');
    document.body.classList.add('overflow-hidden', 'collections-filter-drawer-open');

    htmlLockStyles.position = document.documentElement.style.position;
    htmlLockStyles.top = document.documentElement.style.top;
    htmlLockStyles.left = document.documentElement.style.left;
    htmlLockStyles.right = document.documentElement.style.right;
    htmlLockStyles.width = document.documentElement.style.width;
    htmlLockStyles.height = document.documentElement.style.height;
    document.documentElement.style.position = 'fixed';
    document.documentElement.style.top = '0';
    document.documentElement.style.left = '0';
    document.documentElement.style.right = '0';
    document.documentElement.style.width = '100%';
    document.documentElement.style.height = '100%';

    bodyLockStyles.position = document.body.style.position;
    bodyLockStyles.top = document.body.style.top;
    bodyLockStyles.left = document.body.style.left;
    bodyLockStyles.right = document.body.style.right;
    bodyLockStyles.width = document.body.style.width;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.documentElement.classList.remove('overflow-hidden', 'collections-filter-drawer-open');
    document.body.classList.remove('overflow-hidden', 'collections-filter-drawer-open');

    document.documentElement.style.position = htmlLockStyles.position;
    document.documentElement.style.top = htmlLockStyles.top;
    document.documentElement.style.left = htmlLockStyles.left;
    document.documentElement.style.right = htmlLockStyles.right;
    document.documentElement.style.width = htmlLockStyles.width;
    document.documentElement.style.height = htmlLockStyles.height;

    document.body.style.position = bodyLockStyles.position;
    document.body.style.top = bodyLockStyles.top;
    document.body.style.left = bodyLockStyles.left;
    document.body.style.right = bodyLockStyles.right;
    document.body.style.width = bodyLockStyles.width;
    window.scrollTo(0, scrollY);
  }

  var closeBtn = drawer.querySelector('[data-collections-filter-close]');
  var overlay = drawer.querySelector('.collections-filter-drawer__overlay');
  var applyBtn = drawer.querySelector('[data-collections-filter-apply]');
  var sections = drawer.querySelectorAll('.collections-filter-drawer__section');
  var scrollEl = drawer.querySelector('.collections-filter-drawer__scroll');

  var urlSort = new URLSearchParams(window.location.search).get('sort_by');
  var selectedSort = urlSort || 'best-selling';

  if (urlSort) {
    drawer.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.dataset.sortValue === urlSort);
    });
  }

  var initialSelected = drawer.querySelector('[data-sort-value].is-selected');
  if (initialSelected) selectedSort = initialSelected.dataset.sortValue;

  var panelSlide = drawer.querySelector('.collections-filter-drawer__panel-slide');
  var DRAWER_TRANSITION_MS = 300;

  function openDrawer() {
    if (drawer.classList.contains('is-open') || drawer.classList.contains('is-closing')) return;

    drawer.classList.remove('is-closing');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    enableViewportSync();
    if (overscrollCleanup) overscrollCleanup();
    overscrollCleanup = bindOverscrollPrevention(scrollEl);
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!drawer.classList.contains('is-open') || drawer.classList.contains('is-closing')) return;

    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (overscrollCleanup) {
      overscrollCleanup();
      overscrollCleanup = null;
    }

    var finished = false;

    function finishClose() {
      if (finished) return;
      finished = true;
      drawer.classList.remove('is-closing');
      disableViewportSync();
      unlockScroll();
      if (panelSlide) panelSlide.removeEventListener('transitionend', onTransitionEnd);
    }

    function onTransitionEnd(event) {
      if (event.target === panelSlide && event.propertyName === 'transform') {
        finishClose();
      }
    }

    if (panelSlide) panelSlide.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finishClose, DRAWER_TRANSITION_MS + 50);
  }

  if (openBtn) {
    openBtn.addEventListener('click', openDrawer);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  sections.forEach(function (section) {
    var toggle = section.querySelector('.collections-filter-drawer__section-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      var isExpanded = section.classList.contains('is-expanded');
      section.classList.toggle('is-expanded', !isExpanded);
      toggle.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
    });
  });

  function getDrawerProductAndBenefitTags() {
    var productTags = [];
    drawer.querySelectorAll('[data-filter-product]:checked').forEach(function (input) {
      productTags.push(input.dataset.filterProduct);
    });
    var benefitTags = [];
    drawer.querySelectorAll('[data-filter-benefit]:checked').forEach(function (input) {
      benefitTags.push(input.dataset.filterBenefit);
    });
    return { productTags: productTags, benefitTags: benefitTags };
  }

  function syncDrawerHairtoneAvailability() {
    if (!window.HairtonesCollectionFilters || !window.HairtonesCollectionFilters.updateHairtoneAvailability) return;
    var tags = getDrawerProductAndBenefitTags();
    window.HairtonesCollectionFilters.updateHairtoneAvailability(tags.productTags, tags.benefitTags);
  }

  function getDrawerFilterState() {
    var hairtoneBtn = drawer.querySelector('[data-drawer-hairtone].is-selected:not(.is-unavailable)');
    var hairtoneValue = hairtoneBtn ? hairtoneBtn.dataset.drawerHairtone : 'all';
    var productTags = [];
    drawer.querySelectorAll('[data-filter-product]:checked').forEach(function (input) {
      productTags.push(input.dataset.filterProduct);
    });
    var benefitTags = [];
    drawer.querySelectorAll('[data-filter-benefit]:checked').forEach(function (input) {
      benefitTags.push(input.dataset.filterBenefit);
    });
    return { hairtone: hairtoneValue, productTags: productTags, benefitTags: benefitTags };
  }

  function navigateToBestSellingWithDrawerState() {
    if (selectedSort !== 'best-selling') return false;
    if (window.HairtonesCollectionFilters && !window.HairtonesCollectionFilters.needsBrowserReloadForBestSelling()) {
      return false;
    }
    var currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort === 'best-selling') return false;

    var state = getDrawerFilterState();
    try {
      sessionStorage.setItem('hairtonesDrawerState', JSON.stringify({
        hairtone: state.hairtone,
        productTags: state.productTags,
        benefitTags: state.benefitTags
      }));
    } catch (e) {}
    var reloadUrl = new URL(window.location.href);
    reloadUrl.searchParams.set('sort_by', 'best-selling');
    window.location.href = reloadUrl.toString();
    return true;
  }

  drawer.querySelectorAll('[data-sort-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      drawer.querySelectorAll('[data-sort-value]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      selectedSort = btn.dataset.sortValue;

      if (navigateToBestSellingWithDrawerState()) return;

      if (window.HairtonesCollectionFilters && window.HairtonesCollectionFilters.applySortBy) {
        window.HairtonesCollectionFilters.applySortBy(selectedSort);
      }

      closeDrawer();
    });
  });

  drawer.querySelectorAll('[data-filter-product], [data-filter-benefit]').forEach(function (input) {
    input.addEventListener('change', syncDrawerHairtoneAvailability);
  });

  drawer.querySelectorAll('[data-drawer-hairtone]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-unavailable')) return;

      drawer.querySelectorAll('[data-drawer-hairtone]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
    });
  });

  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var state = getDrawerFilterState();

      if (window.HairtonesCollectionFilters) {
        window.HairtonesCollectionFilters.applyFromDrawer({
          hairtone: state.hairtone,
          productTags: state.productTags,
          benefitTags: state.benefitTags
        });
      }

      closeDrawer();
    });
  }
});
